import React, { useState } from "react";
import { connect } from "react-redux";
import {
  setpersonalizzazione,
  setclubcolletto,
  setclubpolsino,
  setcontrastocolletto,
  setcontrastopolsino,
  setcontrastochiusura,
  setfiltripersonalizza,
  setvista,
  setmask,
  setopenmain,
  setricambio
} from "../../state/actions";

import Drawer from "@mui/material/Drawer";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import Colletti from "../navigazione/colletti";
import Polsini from "../navigazione/polsini";
import Chiusure from "../navigazione/chiusure";
import Taschini from "../navigazione/taschini";
import Contrasti from "../navigazione/contrasti";
import Asole from "../navigazione/asole";
import Bottoni from "../navigazione/bottoni";
import Fili from "../navigazione/fili";
import Pinces from "../navigazione/pinces";
import Fondo from "../navigazione/fondo";
import Vestibilita from "../navigazione/vestibilita";
import Maniche from "../navigazione/maniche";

import Iniziali from "../iniziali";

import { prices } from "../../data";
import { euro } from "../helpers";

const Personalizzazione = (props) => {
  const {
    lingua,
    pers,
    setPers,
    clubColletto,
    clubPolsino,
    setClubColletto,
    setClubPolsino,

    filtriPersonalizzazione,
    setFiltriPersonalizza,
    setVista,
    openMain,
    setOpenMain,
    setRicambio,
    ricambio
  } = props;

  let personal = <Colletti lingua={lingua} />;

  switch (pers) {
    case "colletti":
      personal = <Colletti lingua={lingua} />;
      break;
    case "polsini":
      personal = <Polsini lingua={lingua} />;
      break;
    case "maniche":
      personal = <Maniche lingua={lingua} />;
      break;
    case "chiusure":
      personal = <Chiusure lingua={lingua} />;
      break;
    case "taschini":
      personal = <Taschini lingua={lingua} />;
      break;
    case "contrasti":
      personal = <Contrasti lingua={lingua} />;
      break;
    case "asole":
      personal = <Asole lingua={lingua} />;
      break;
    case "bottoni":
      personal = <Bottoni lingua={lingua} />;
      break;

    case "fili":
      personal = <Fili lingua={lingua} />;
      break;

    case "iniziali":
      personal = <Iniziali lingua={lingua} />;
      break;

    case "pinces":
      personal = <Pinces lingua={lingua} />;
      break;
    case "fondo":
      personal = <Fondo lingua={lingua} />;
      break;
    case "fit":
      personal = <Vestibilita lingua={lingua} />;
      break;

    case "contrasti":
      personal = <Contrasti lingua={lingua} />;
      break;

    default:
      personal = <Colletti lingua={lingua} />;
  }

  const setPersonalizzazione = (tipo) => {
    setPers(tipo);
  };

  const [aperto, setAperto] = useState(false);

  return (
    <>
      <Drawer
        anchor={"left"}
        open={aperto}
        onClose={() => setAperto(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          zIndex: 10000,
          width: 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 260,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setAperto(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <aside
          className="menu"
          style={{
            height: "calc(100vh - 3rem)",
            overflowY: "scroll",
            padding: "0 1.5rem 1.5rem 1.5rem",
          }}
        >
          <div className="menu-list">
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "colletti"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("colletti");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.colletto}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "polsini"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("polsini");
                setAperto(false);
                setVista(2);
              }}
            >
              {lingua.navigazione.polsino}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "maniche"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("maniche");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.manica}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "chiusure"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("chiusure");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.chiusura}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "taschini"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("taschini");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.taschino}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "pinces"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("pinces");
                setAperto(false);
                setVista(2);
              }}
            >
              {lingua.navigazione.pinces}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "fondo"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("fondo");
                setAperto(false);
                setVista(1);
              }}
            >
              {lingua.navigazione.fondo}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "fit"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("fit");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.vestibilita}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "contrasti"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("contrasti");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.contrasto}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "bottoni"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("bottoni");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.bottoni}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "asole"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("asole");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.asole}
            </button>

            <button
              style={{ fontSize: "1rem" }}
              className={
                pers === "fili"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("fili");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.fili}
            </button>

            <button
              style={{
                fontSize: "1rem",
              }}
              className={
                pers === "iniziali"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setPersonalizzazione("iniziali");
                setAperto(false);
                setVista(0);
              }}
            >
              {lingua.navigazione.iniziali.iniziali} € 5.00
            </button>
          </div>

          {pers === "colletti" && (
            <div className="menu-list">
              <div className="panel-block">
                <Tooltip
                  title={
                    prices.clubColletto > 0
                      ? "+ " + euro(prices.clubColletto)
                      : null
                  }
                >
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        checked={clubColletto}
                        id="idclub"
                        onChange={() => setClubColletto(!clubColletto)}
                      />
                    }
                    label="Club"
                  />
                </Tooltip>
              </div>
            </div>
          )}
          {pers === "polsini" && (
            <div className="menu-list">
              <div className="panel-block">
                <Tooltip
                  title={
                    prices.clubPolsino > 0
                      ? "+ " + euro(prices.clubPolsino)
                      : null
                  }
                >
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        checked={clubPolsino}
                        id="idclub"
                        onChange={() => setClubPolsino(!clubPolsino)}
                      />
                    }
                    label="Club"
                  />
                </Tooltip>
              </div>
            </div>
          )}

<div className="menu-list">
              <div className="panel-block">
                
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        checked={ricambio}
                        id="idclub"
                        onChange={() => setRicambio(!ricambio)}
                      />
                    }
                    label="Colletto e polsino di ricambio € 10.00"
                  />
                
              </div>
            </div>

        </aside>
      </Drawer>

      <Drawer
        anchor={"left"}
        open={openMain}
        onClose={() => setOpenMain(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: 320,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white"
            onClick={() => setAperto(true)}
          >
            <span className="icon">
              <MenuIcon />
            </span>
            <span className="ml-2">Seleziona personalizzazione</span>
          </button>

          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setOpenMain(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <div
          style={{ height: "calc(100vh - 3rem)", overflowY: "scroll" }}
          
        >
          <div style={{padding: "0 1.5rem 1.5rem 1.5rem"}}>
          {personal}
          </div>
        </div>
      </Drawer>

      
        <div className="container-features" style={{ background: "#fff" }}>
          <div className="p-3">
            <button
              className="button is-small is-white"
              onClick={() => setAperto(true)}
            >
              <span className="icon">
                <MenuIcon />
              </span>
              <span className="ml-2">Seleziona personalizzazione</span>
            </button>
          </div>

          <div style={{ height: "calc(100vh - 6.6rem)", overflowY: "scroll" }}>
            <div
              className="section"
              style={{ padding: "0 1.5rem 1.5rem 1.5rem" }}
            >
              {personal}
            </div>
          </div>
        </div>
      
    </>
  );
};

function mapStateToProps(state) {
  return {
    pers: state.shop.personalizzazione,
    mask: state.shop.camicia.mask,
    clubColletto: state.shop.camicia.clubColletto,
    clubPolsino: state.shop.camicia.clubPolsino,
    colletto: state.shop.camicia.contrastoColletto,
    polsino: state.shop.camicia.contrastoPolsino,
    chiusura: state.shop.camicia.contrastoChiusura,
    filtriPersonalizzazione: state.shop.filtriPersonalizza,
    openMain: state.shop.openMain,
    ricambio: state.shop.camicia.ricambio,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPers: (val) => dispatch(setpersonalizzazione(val)),
    setMask: (val) => dispatch(setmask(val)),
    setClubColletto: (val) => dispatch(setclubcolletto(val)),
    setClubPolsino: (val) => dispatch(setclubpolsino(val)),
    setColletto: (val) => dispatch(setcontrastocolletto(val)),
    setPolsino: (val) => dispatch(setcontrastopolsino(val)),
    setChiusura: (val) => dispatch(setcontrastochiusura(val)),
    setFiltriPersonalizza: (val) => dispatch(setfiltripersonalizza(val)),
    setVista: (val) => dispatch(setvista(val)),
    setOpenMain: (val) => dispatch(setopenmain(val)),
    setRicambio:  (val) => dispatch(setricambio(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Personalizzazione);
